import { render, staticRenderFns } from "./UserEditDetails.vue?vue&type=template&id=3edd21a3&scoped=true"
import script from "./UserEditDetails.vue?vue&type=script&lang=js"
export * from "./UserEditDetails.vue?vue&type=script&lang=js"
import style0 from "./UserEditDetails.vue?vue&type=style&index=0&id=3edd21a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edd21a3",
  null
  
)

export default component.exports